import { ServiceResult } from './ServiceResult';

export class UnAuthorizedServiceResult extends ServiceResult {

    constructor(successful: boolean, response: string) {
        super(successful, response);
    } 

}